export default __webpack_public_path__ + "static/media/bg.ea3a69c2.jpg";